var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record-tab"},[_c('div',{class:['tab-item ', _vm.activeIndex == 1 ? 'active' : ''],on:{"click":function($event){return _vm.$emit('click', 1)}}},[_vm._v(" 来程订票 ")]),_c('div',{class:['tab-item ', _vm.activeIndex == 2 ? 'active' : ''],on:{"click":function($event){return _vm.$emit('click', 2)}}},[_vm._v(" 返程订票 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }